<div class="cropper-picture-modal">
  <md-dialog-content>
    <app-spinner *ngIf="loading"></app-spinner>
    <div class="containers" *ngIf="!loading">
      <div class="saving-overlay" *ngIf="saving"></div>
      <md2-tabs [selectedIndex]="selectedIndex">
        <md2-tab
          label="Original"
          [active]="data.optional2 === 'Original'"
          *ngIf="editMode"
        >
          <div>
            HD
            <md-slide-toggle
              [checked]="is4K"
              (change)="changePictureType($event)"
            ></md-slide-toggle>
            4K
            <md-form-field>
              <input
                mdInput
                name="equinox"
                placeholder="Equinoxe Id"
                [(ngModel)]="equinoxeTerm"
                type="number"
                max="999999999"
              />
            </md-form-field>
            <button
              md-raised-button
              color="primary"
              type="submit"
              (click)="getEquinoxePicture()"
            >
              <md-icon>add</md-icon>
              Add
            </button>
            <button
              *ngIf="
                (getETTPictureByFormat('Original').pictureURL ||
                  getETTPictureByFormat('Original').blob) &&
                focalPointEnabled
              "
              md-raised-button
              color="accent"
              (click)="activateFocalPoint()"
              style="margin-left: 100px"
            >
              <md-icon>adjust</md-icon>
              Focal point
            </button>
          </div>
          <i *ngIf="!focalPointModeOn"
            >Click on the picture below or drag and drop to upload your own
            picture</i
          ><i *ngIf="focalPointModeOn"
            >Click on the picture to choose your focal point</i
          >
          <input
            id="file_upload_cropper"
            type="file"
            style="visibility: hidden; display: none"
            (change)="fileChange($event)"
            [(ngModel)]="file"
          />
          <div (drop)="onDrop($event)" (dragover)="onDragOver($event)">
            <img
              class="original"
              [ngClass]="{ focalmode: focalPointModeOn }"
              *ngIf="getETTPictureByFormat('Original')"
              [src]="
                getETTPictureByFormat('Original').pictureURL ||
                getETTPictureByFormat('Original').blob ||
                'https://i.eurosport.com/taiga/Pictogram/placeholder1.png'
              "
              (click)="upload($event)"
            />
          </div>
        </md2-tab>
        <md2-tab
          label="Original"
          [active]="data.optional2 === 'Original'"
          *ngIf="!editMode"
        >
          <img
            class="original"
            *ngIf="getETTPictureByFormat('Original')"
            [src]="
              getETTPictureByFormat('Original').pictureURL ||
              getETTPictureByFormat('Original').blob
            "
          />
        </md2-tab>
        <md2-tab
          *ngFor="let item of format"
          label="{{ item }}"
          [active]="data.optional2 === item"
        >
          <ng-container #croppers *ngFor="let cropper of croppersFormat">
            <app-picture-cropper
              *ngIf="
                getETTPictureByFormat('Original') &&
                cropper == createCropperFormat(item)
              "
              #cropper
              format="{{ createFormatWithUnderscore(item) }}"
              [url]="
                getETTPictureByFormat('Original').pictureURL ||
                getETTPictureByFormat('Original').blob
              "
              [src]="getETTPictureByFormat(item).pictureURL"
              [editMode]="editMode"
              [is4K]="is4K"
            ></app-picture-cropper>
          </ng-container>

          <br />
          <span>{{
            getWidthHeightFromFormat(createFormatWithUnderscore(item))
          }}</span>
        </md2-tab>
      </md2-tabs>
    </div>
  </md-dialog-content>
  <md-dialog-actions *ngIf="editMode">
    <div class="error">{{ errorMessage }}</div>
    <div class="filesize">{{ fileSize }}</div>
    <app-spinner *ngIf="saving"></app-spinner>
    <div>
      <app-spinner *ngIf="loadingFocalPoint"></app-spinner>
    </div>
    <div class="buttons">
      <button md-raised-button md-dialog-close [disabled]="saving">
        <md-icon>cancel</md-icon>
        Cancel
      </button>
      <button
        md-raised-button
        color="accent"
        (click)="uploadPicture()"
        [disabled]="saving || loadingFocalPoint"
      >
        <md-icon *ngIf="data.type === 'translate'">save</md-icon>
        <span *ngIf="data.type === 'translate'">Save</span>
        <md-icon *ngIf="data.type !== 'translate'">check</md-icon>
        <span *ngIf="data.type !== 'translate'">OK</span>
      </button>
    </div>
  </md-dialog-actions>
</div>



// WEBPACK FOOTER //
// ./src/app/modals/cropper-picture-modal/cropper-picture-modal.component.html